// @flow
import type { Plane } from '../types';
import * as constants from '../constants/planeConstants';

type SetPlaneAction = {|
    type: typeof constants.SET,
    data: Plane
|};

type UnsetPlaneAction = {|
    type: typeof constants.UNSET,
    data: Plane
|};

type SetPlanesAction = {|
    type: typeof constants.BATCH_SET,
    data: $ReadOnly<{[icao: string]: $ReadOnlyArray<Plane>}>
|};

type EndPlaneSessionAction = {|
    type: typeof constants.END_SESSION,
    data: string
|};

export type PlaneAction = SetPlaneAction | UnsetPlaneAction | EndPlaneSessionAction;


export default {
    setPlane: (car: Plane): SetPlaneAction => ({
        type: constants.SET,
        data: car
    }),
    unsetPlane: (plane: Plane) => ({
        type: constants.UNSET,
        data: plane
    }),
    setPlanes: (planes: $ReadOnly<{[icao: string]: $ReadOnlyArray<Plane>}>): SetPlanesAction => ({
        type: constants.BATCH_SET,
        data: planes
    }),
    endSession: (icao: string): EndPlaneSessionAction => ({
        type: constants.END_SESSION,
        data: icao
    })
};